import { useEffect, useState } from 'react'
import { folderService } from 'services';

const useFolderList = (payload) => {
  const [data, setData] = useState(false);

  const getFolderList = async () => {
    try {
      const response = await folderService.folderlist(payload);
      setData(response?.data?.data);

    } catch (err) {
      console.error(err?.response);
    }
  };
  useEffect(() => {
    getFolderList();
  }, [payload?.limit]);

  return { foldersData: data };
}

export default useFolderList
